import angular from 'angular'

import { PosStateManager } from '../managers/pos-state-manager'

/**
 * Initialises the posStateManager.
 *
 * @module webregister.resolvers.posStateManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory(
    'posStateManagerResolver',
    function (posStateManager: PosStateManager) {
      return posStateManager.init()
    }
  )
